const env = window.config;
export default env;
